import { Component } from "vue-property-decorator";
import { Block } from '../../../helpers/components';
import BaseBlock from "@/blocks/base-block";
import { ReservationForm } from '../../../components/reservation-form/reservation-form';

@Block() @Component({
	components: {
		ReservationForm
	}
})
export class ReservationFormModal extends BaseBlock {

	opened() {
		const trackModalOpen = (window as any).trackModalOpen;

		if (typeof trackModalOpen === "function") {
			trackModalOpen();
		}
	}
}

export default ReservationFormModal;
